
export const getDimension = (units: string): string => {
    if (units === '')
        return '°C'
    if (units === 'metric')
        return '°C'
    if (units === 'standard')
        return 'K'
    if (units === 'imperial')
        return '°F'

    return '°C'

}